// filepath: /Users/mason/Documents/Code/mason-portfolio/src/components/GalleryImage.js
import React from "react";

const GalleryImage = ({ image, onImageClick }) => {
	return (
		<div
			className="relative h-64 bg-slate-100 rounded-xl ring-1 ring-slate-200/70 flex items-center justify-center overflow-hidden cursor-pointer group"
			onClick={() => onImageClick(image)}
		>
			<img
				src={image.src}
				alt={image.alt}
				className="object-cover w-full h-full transition-transform duration-500 ease-out group-hover:scale-110"
				loading="lazy" // Add lazy loading for better performance
			/>
			<div className="absolute inset-0 bg-gradient-to-t from-slate-950/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
		</div>
	);
};

export default GalleryImage;
